import React from 'react';

import { ChevronLeftOutlined, ChevronRightOutlined } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';

type Props = {
  currentPage?: number;
  limit?: number;
  setPage: (v: number) => void;
  count?: number;
};
export default function PaginationButtons({ setPage, currentPage, limit, count }: Props) {
  if (count === undefined || currentPage === undefined || limit === undefined) {
    return (
      <Stack direction="row" alignItems="center">
        <IconButton disabled>
          <ChevronLeftOutlined fontSize="small" />
        </IconButton>
        <IconButton disabled>
          <ChevronRightOutlined fontSize="small" />
        </IconButton>
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="center">
      <IconButton disabled={currentPage <= 1} onClick={() => setPage(currentPage - 1)}>
        <ChevronLeftOutlined fontSize="small" />
      </IconButton>
      <IconButton disabled={currentPage >= Math.ceil(count / limit)} onClick={() => setPage(currentPage + 1)}>
        <ChevronRightOutlined fontSize="small" />
      </IconButton>
    </Stack>
  );
}
